import React from 'react';

const FilterIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="16"
    height="14"
    viewBox="0 0 16 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.121726 0.715647C0.328 0.278133 0.765551 0 1.24998 0H14.7516C15.236 0 15.6735 0.278133 15.8798 0.715647C16.0861 1.15316 16.0236 1.6688 15.7173 2.04381L10.001 9.0284V13.0004C10.001 13.3785 9.78848 13.7254 9.44782 13.8942C9.10715 14.0629 8.70398 14.0286 8.40082 13.8004L6.40059 12.3004C6.14743 12.1129 6.00054 11.816 6.00054 11.5003V9.0284L0.28112 2.04069C-0.0220409 1.6688 -0.0876736 1.15003 0.121726 0.715647Z"
      fill="black"
    />
  </svg>
);

export default FilterIcon;
